module.exports = __webpack_public_path__ + "static/media/tickRepair.f57cbfe9.wav";